var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtRoundCurrency({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 47,
    fill: "#272B34"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 46.5,
    stroke: "url(#paint0_linear)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7236 48.8899L36.5399 34.8457C36.5589 34.7984 36.5895 34.7584 36.6278 34.7306C36.6662 34.7028 36.7107 34.6884 36.756 34.689H56.543C56.5881 34.6889 56.6323 34.7037 56.6703 34.7317C56.7083 34.7597 56.7385 34.7996 56.7572 34.8468L62.5735 48.891C62.5956 48.9432 62.6026 49.0022 62.5935 49.0594C62.5844 49.1165 62.5596 49.1688 62.5227 49.2086L46.8144 66.5111C46.7698 66.5602 46.7104 66.5877 46.6485 66.5877C46.5867 66.5877 46.5273 66.5602 46.4827 66.5111L30.7744 49.2075C30.7375 49.1677 30.7127 49.1154 30.7036 49.0583C30.6945 49.0011 30.7015 48.9421 30.7236 48.8899ZM46.6709 50.382C47.9706 50.382 48.5532 50.342 48.666 50.3323L48.6622 50.3312C52.6497 50.1281 55.6241 49.3287 55.6241 48.3737C55.6241 47.4187 52.6488 46.6192 48.6622 46.4151V49.5372C48.5504 49.5491 47.9292 49.6085 46.6887 49.6085C45.655 49.6085 44.9069 49.5577 44.6457 49.5361V46.4129C40.6507 46.6182 37.6688 47.4165 37.6688 48.3737C37.6688 49.3309 40.6507 50.1303 44.6457 50.3323C44.9031 50.3464 45.6371 50.382 46.6709 50.382ZM48.666 46.091V46.092L48.6651 46.091C48.6654 46.091 48.6657 46.091 48.666 46.091ZM48.666 43.2972V46.091C53.1793 46.3309 56.5704 47.3594 56.5704 48.5919C56.5704 49.8246 53.176 50.853 48.6651 51.0918V60.0509H44.6447V51.095C40.1235 50.8552 36.7234 49.8267 36.7234 48.593C36.7234 47.3593 40.1235 46.3297 44.6447 46.091V43.2972H39.0822V39.0354H54.2295V43.2972H48.666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 0,
    y: 0,
    width: 99,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.3513,
    y1: 86.8513,
    x2: 117.351,
    y2: 15.8513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDDF96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8987,
    height: 31.8987,
    fill: "white",
    transform: "translate(30.6987 34.6892)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtRoundCurrency);
export default __webpack_public_path__ + "static/media/usdt-round-currency.41f5bc21849c57be3ae8ca43ec0b43cb.svg";
export { ForwardRef as ReactComponent };